module.exports = __webpack_public_path__ + "static/Pt15-66fdcc3d9706d1cd4db08b84d2b89efe.jpg";